import type { CityConfig } from "@/pages/city-template/types";

export const winslowConfig: CityConfig = {
  city: "Winslow",
  state: "Arizona",
  stateAbbr: "AZ",
  slug: "winslow",
  route: "/cities/winslow",
  title: "Emergency & Expedited Passport Services Winslow AZ | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Winslow, AZ — as fast as 24 hours. No Winslow passport agency. Fast Passport Center couriers to the Western Passport Center in Tucson, about 260 miles south. A+ BBB rated. Serving Navajo County residents, BNSF Railway workers, Hopi and Navajo Nation members, Historic Route 66 travelers, and La Posada visitors.",
  h1: "Emergency & Expedited Passport Services in Winslow, AZ",
  heroSubtitle: "Winslow sits on Historic Route 66 and the BNSF Railway transcontinental line in Navajo County, about 260 miles from the Western Passport Center in Tucson. Fast Passport Center's registered couriers deliver your documents to Tucson so you get a new or renewed passport as fast as 24 hours — whether you're a BNSF Railway professional with international training opportunities, a Hopi or Navajo Nation member with cross-border family connections, a Route 66 traveler extending the journey internationally, or a Navajo County family planning the trip of a lifetime.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Winslow%20Arizona%20Historic%20Route%2066%20standing%20on%20the%20corner%20with%20classic%20southwestern%20architecture%20and%20vintage%20Americana%20vibe%2C%20high%20desert%20landscape%20with%20distant%20mesas%20and%20red%20rock%20formations%20under%20vast%20blue%20sky%2C%20nostalgic%20small%20railroad%20town%20atmosphere%20with%20warm%20golden%20light%2C%20professional%20landscape%20photography%2C%20clean%20composition%2C%20no%20people%20visible&width=1800&height=700&seq=wi-hero-001&orientation=landscape",
  heroImageAlt: "Winslow Arizona Historic Route 66 downtown with high desert landscape",
  geoPosition: "35.0242;-110.6974",
  geoPlacename: "Winslow, Arizona",
  lastModified: "2026-06-06",
  regionalAgency: {
    name: "Western Passport Center",
    address: "733 N Stone Ave, Tucson, AZ 85701",
    distance: "Approximately 260 miles from Winslow — about 4 hours via I-40, AZ-87, and I-10",
  },
  nearbyCitiesZips: [
    { name: "Winslow", zips: "86047" },
    { name: "Holbrook", zips: "86025" },
    { name: "Joseph City", zips: "86032" },
    { name: "Snowflake", zips: "85937" },
    { name: "Taylor", zips: "85939" },
    { name: "Show Low", zips: "85901, 85902" },
    { name: "Leupp", zips: "86035" },
    { name: "Dilkon", zips: "86047" },
    { name: "Flagstaff", zips: "86001, 86004" },
    { name: "Window Rock", zips: "86515" },
    { name: "Gallup NM", zips: "87301" },
    { name: "Chambers", zips: "86502" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Courier delivery to Western Passport Center in Tucson — 260 miles from Winslow" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-map-pin-2-line", title: "Northeast Arizona Hub", desc: "Serving Winslow, Holbrook, Joseph City, and all Navajo County eastern communities" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your Winslow case from start to finish" },
  ],
  internalLinks: [
    { name: "Emergency passport in Holbrook AZ", route: "/cities/holbrook" },
    { name: "Expedited passport in Flagstaff AZ", route: "/cities/flagstaff" },
    { name: "Urgent passport in Phoenix AZ", route: "/cities/phoenix" },
    { name: "Arizona passport hub", route: "/states/arizona" },
    { name: "Fast passport in Show Low AZ", route: "/cities/show-low" },
    { name: "Emergency passport in Scottsdale AZ", route: "/cities/scottsdale" },
    { name: "Expedited passport in Tempe AZ", route: "/cities/tempe" },
  ],
  fpcOfficeAddress: "733 N Stone Ave, Tucson, AZ 85701",
  fpcOfficeNote: "Fast Passport Center serves Winslow remotely via secure courier. Our registered couriers hand-deliver your documents to the Western Passport Center in Tucson. Winslow is approximately 260 miles from Tucson — about 8 hours round trip through the high desert and mountains. That is an entire workday lost just to reach the passport agency. Our courier service makes the trip so you don't have to, serving one of Arizona's most historically significant — and geographically remote — towns.",
  fpcOfficeDistance: "Serving all of northeastern Navajo County and the I-40 corridor",
  serviceAreaIntro: "Fast Passport Center provides emergency and fast passport renewal services throughout Winslow, Holbrook, Joseph City, and the I-40 corridor in northeastern Arizona. From BNSF Railway workers and La Posada hospitality professionals to Hopi and Navajo Nation members and Historic Route 66 tourists, we help northeastern Arizona travelers get passports fast without the 520-mile Tucson round trip.",
  nearbyCitiesIntro: "We serve Winslow and nearby communities including Holbrook, Joseph City, Snowflake, Taylor, Leupp, and the entire I-40 corridor in Navajo County and eastern Coconino County.",
  howItWorksIntro: "Most Winslow travelers complete everything online and ship documents overnight. At about 260 miles from Tucson — an 8-hour round trip through the Arizona high desert — Fast Passport Center provides essential courier turnaround for one of Arizona's most remote and iconic communities on Historic Route 66.",
  mistakesIntro: "Winslow travelers, including BNSF Railway professionals and Navajo County families, face unique passport challenges specific to remote high desert communities. Here are the most common mistakes we see.",
  testimonialsIntro: "Winslow and northeastern Arizona travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Winslow? Here are the most common ones we hear from I-40 corridor and Navajo County residents.",
  statePageRoute: "/states/arizona",
  statePageName: "Arizona",
  dmvWebsite: "https://azdot.gov/motor-vehicles",
  dmvLabel: "Arizona MVD — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "260 miles to Tucson (4-hour drive each way)",
        "Still requires pre-scheduled NPIC appointment",
      ],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "No 8-hour round-trip drive to Tucson needed",
        "Ideal for BNSF Railway international travel",
        "Perfect for Navajo County families on vacation",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service USPS",
        "Good for planned travel from FLG or PHX",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "No document review — errors cause rejection",
        "In-person clerk appointment required",
        "Workload shifts with government shutdowns",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "Cannot upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "Winslow is 260 miles from Tucson. Don't waste an 8-hour round trip through the high desert — our couriers deliver to the Western Passport Center for you.",
      bullets: ["Northeast AZ coverage", "24–48 hour turnaround available", "No 8-hour Tucson drive needed"],
      badge: "Fastest in AZ",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Winslow adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No acceptance clerk visit for most renewals", "Mail-in or courier options", "Serving Winslow and Navajo County"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support in Winslow and Navajo County.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Fast replacement for Winslow, Holbrook, and Route 66 corridor residents with DS-64 form guidance.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement via Tucson agency"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support in Navajo County.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport name change service after marriage, divorce, or legal changes for Winslow and Navajo County residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Winslow AZ", description: "Urgent passport processing for Winslow, AZ travelers via Western Passport Center courier — about 260 miles from Winslow." },
    { name: "Passport Renewal Winslow AZ", description: "Fast passport renewal for Winslow and Navajo County, Arizona residents." },
    { name: "New Passport Winslow AZ", description: "First-time passport application assistance for Winslow and I-40 corridor residents." },
    { name: "Lost Passport Winslow AZ", description: "Passport replacement for lost or stolen passports for Winslow and northeastern Arizona residents." },
    { name: "Child Passport Winslow AZ", description: "Minor passport services for Winslow and Navajo County families." },
    { name: "Name Change Passport Winslow AZ", description: "Passport name change service for Winslow, AZ residents." },
  ],
  testimonials: [
    {
      name: "David M.",
      location: "Winslow, AZ",
      rating: 5,
      text: "BNSF Railway engineer — our union offered a two-week training exchange program with Deutsche Bahn in Germany. Three weeks notice, and my passport was expired. Fast Passport Center got me renewed in 4 business days. The Winslow-to-Tucson drive would have taken an entire day off work. This service is a game-changer for railroad families.",
      service: "Expedited Renewal",
    },
    {
      name: "The Begay Family",
      location: "Winslow, AZ",
      rating: 5,
      text: "Navajo family with relatives in both Arizona and Sonora, Mexico. Needed passports for all four of us for a family gathering in Hermosillo. Fast Passport Center processed everything in 7 business days. The DS-11 guidance for our two kids was incredibly helpful — we had no idea what documents we needed.",
      service: "Family Passport Package",
    },
    {
      name: "Linda H.",
      location: "Joseph City, AZ",
      rating: 5,
      text: "Retired teacher who decided to take a bucket list trip to Ireland with my sisters. Realized 3 weeks before departure that my passport had expired 2 years ago. Fast Passport Center got me a renewal in 5 business days. Didn't have to cancel the trip of a lifetime. The daily updates kept me from panicking.",
      service: "Expedited Renewal",
    },
    {
      name: "Tom W.",
      location: "Holbrook, AZ",
      rating: 5,
      text: "La Posada Hotel hospitality manager — got offered a hospitality industry conference in Barcelona with 12 days notice. Never had a passport. Fast Passport Center guided me through every step. New passport in 6 business days. The dedicated agent was incredible — he told me exactly what to do and where to go.",
      service: "New Passport",
    },
  ],
  facilities: [
    {
      id: "wi-1",
      name: "Winslow Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "223 N Williamson Ave",
      city: "Winslow",
      state: "AZ",
      zip: "86047",
      phone: "(928) 289-3634",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Winslow",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary acceptance facility for Winslow and eastern Navajo County residents. Located on Historic Route 66 (Williamson Avenue). Appointment required.",
      icon: "ri-mail-line",
    },
    {
      id: "wi-2",
      name: "Holbrook Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "100 W Erie St",
      city: "Holbrook",
      state: "AZ",
      zip: "86025",
      phone: "(928) 524-3311",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "30 miles east in Holbrook",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Alternative acceptance facility serving Holbrook and eastern Navajo County residents.",
      icon: "ri-mail-line",
    },
    {
      id: "wi-3",
      name: "Navajo County Superior Court — Clerk's Office",
      type: "County Clerk Passport Acceptance",
      address: "100 E Code Talkers Dr",
      city: "Holbrook",
      state: "AZ",
      zip: "86025",
      phone: "(928) 524-4188",
      hours: "Mon–Fri: 8:00 AM – 5:00 PM (passport services by appointment only)",
      distance: "30 miles east in Holbrook",
      website: "https://www.navajocountyaz.gov/Departments/Clerk-of-the-Superior-Court",
      websiteLabel: "Navajo County Clerk",
      notes: "County clerk passport acceptance by appointment. Call ahead to schedule. Serves all Navajo County residents.",
      icon: "ri-building-line",
    },
    {
      id: "wi-4",
      name: "Joseph City Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "4527 Main St",
      city: "Joseph City",
      state: "AZ",
      zip: "86032",
      phone: "(928) 288-3207",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "20 miles east in Joseph City",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Joseph City, Holbrook, and eastern Winslow area residents.",
      icon: "ri-mail-line",
    },
    {
      id: "wi-5",
      name: "Flagstaff Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "2400 N Postal Blvd",
      city: "Flagstaff",
      state: "AZ",
      zip: "86004",
      phone: "(928) 779-2371",
      hours: "Mon–Fri: 9:00 AM – 5:00 PM",
      distance: "60 miles west in Flagstaff",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Largest acceptance facility in northern Arizona with most appointment availability. Convenient for Winslow residents visiting Flagstaff.",
      icon: "ri-mail-line",
    },
    {
      id: "wi-6",
      name: "Show Low Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "191 W Deuce of Clubs",
      city: "Show Low",
      state: "AZ",
      zip: "85901",
      phone: "(928) 537-5787",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "55 miles south in Show Low",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Alternative acceptance facility for southern Navajo County residents. About an hour south of Winslow.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Distance to Tucson Agency", agency: "260 miles — 4-hr drive each way through high desert", fpc: "We drive for you — no 8-hour round trip needed" },
    { feature: "Appointment Needed", agency: "Yes — call NPIC, very limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-map-pin-line",
      title: "Thinking You Can Drive to Tucson in a Day",
      description: "Winslow is 260 miles from Tucson — a 4-hour drive each way via I-40, AZ-87, and I-10 through the high desert. That is an 8-hour round trip — an entire workday — just to reach the Western Passport Center. You still need an appointment. Our courier service eliminates this entirely. Stay on Route 66 and let us handle the Tucson trip.",
    },
    {
      icon: "ri-train-line",
      title: "BNSF Railway Workers — Documentation for International Training",
      description: "BNSF Railway employees in Winslow are frequently offered international training and exchange programs in Europe, Canada, and Japan. These opportunities often come with short notice — 2–3 weeks. Keep your passport current even if you don't have immediate travel plans. Renew it 9 months before expiration to avoid missing career-advancing international opportunities.",
    },
    {
      icon: "ri-file-list-line",
      title: "Tribal Documentation Requirements",
      description: "Hopi and Navajo Nation members applying for U.S. passports need specific documentation. Tribal enrollment cards alone are not sufficient for identity verification for first-time passport applicants. A state-issued photo ID or other acceptable identification is required alongside your certified birth certificate.",
    },
    {
      icon: "ri-calendar-line",
      title: "Seasonal Facility Availability in Rural Arizona",
      description: "Passport acceptance facilities in Winslow and Holbrook have limited hours — typically 9 AM to 4 PM on weekdays only. During summer months when Route 66 tourism peaks, appointments can fill 2–3 weeks in advance. Plan your acceptance facility visit well ahead of your travel date.",
    },
    {
      icon: "ri-image-line",
      title: "Rural Photo Quality Problems",
      description: "Passport photos taken at rural convenience stores and small-town photo services often fail U.S. Department of State standards. Photos must be exactly 2x2 inches, white background, no shadows, neutral expression, and no glasses. Viewing your face from chin to top of head must be exactly 1 to 1 3/8 inches. Improper photos cause application rejection.",
    },
    {
      icon: "ri-snowy-line",
      title: "High Desert Winter Travel Planning",
      description: "Winslow sits at nearly 5,000 feet elevation and experiences freezing temperatures and occasional snow from November through March. Travelers planning winter international trips often wait too long to apply, not accounting for potential weather-related mail delays. Start your passport application 2–3 months before winter international travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send a prepaid overnight label. Drop at any UPS location in Winslow, Holbrook, or Flagstaff." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team reviews every document, then couriers to the Western Passport Center in Tucson — 260 miles south via I-40 and AZ-87." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at the Western Passport Center via our pre-secured courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Winslow or Navajo County address — fully trackable." },
  ],
  faqs: [
    {
      q: "How far is Winslow from a passport agency?",
      a: "Winslow is approximately 260 miles from the Western Passport Center in Tucson — about a 4-hour drive each way via I-40, AZ-87, and I-10. That is an 8-hour round trip through the Arizona high desert. Winslow is one of Arizona's most remote communities from any passport agency. Fast Passport Center's courier service is essential for I-40 corridor residents.",
    },
    {
      q: "Does Winslow have its own passport acceptance facility?",
      a: "Yes. The Winslow Post Office at 223 N Williamson Avenue (Historic Route 66) is a USPS passport acceptance facility. The Holbrook Post Office and Navajo County Superior Court Clerk's Office in Holbrook also offer acceptance services. All require appointments and operate Monday through Friday during business hours.",
    },
    {
      q: "How fast can I get an emergency passport in Winslow?",
      a: "Emergency processing is typically 24–48 hours for Winslow residents. Our couriers deliver directly to the Western Passport Center in Tucson — 260 miles away. This saves you an 8-hour high-desert round-trip drive. Standard expedited processing runs 2–9 business days.",
    },
    {
      q: "Can I fly from Winslow-Lindbergh Regional Airport internationally?",
      a: "Winslow-Lindbergh Regional Airport (INW) serves general aviation only — no commercial passenger service. For international flights, Winslow residents typically use Flagstaff Pulliam Airport (FLG, about 60 miles west) for connections to Phoenix, or Phoenix Sky Harbor International Airport (PHX, about 175 miles southwest). Both require a valid passport book for international connections.",
    },
    {
      q: "I'm a BNSF Railway employee — the railroad sends me to international training. Can you help?",
      a: "Absolutely. BNSF Railway employees in Winslow frequently receive short-notice international training opportunities. Fast Passport Center's 2–9 business day expedited service is ideal for railroad professionals who need passports fast. We recommend keeping your passport current even when you don't have immediate travel plans — renew 9 months before expiration.",
    },
    {
      q: "How do I renew my passport in Winslow?",
      a: "Adult renewals (16 or older, issued within 15 years, same name) can be done by mail with Form DS-82. Fast Passport Center's courier service achieves 2–9 business day turnaround — significantly faster than the 8–11 week standard USPS timeline. This is critical for Winslow residents given the 260-mile distance to Tucson.",
    },
    {
      q: "Where can I get passport photos in Winslow?",
      a: "Passport photo options in Winslow are limited. The closest reliable photo locations are Walgreens and CVS in Flagstaff (about 60 miles west) or Walmart in Show Low (about 55 miles south). The Winslow Post Office may offer photo services — call ahead to confirm. Always verify your photos meet exact specifications before submitting.",
    },
    {
      q: "Do you serve Holbrook and Joseph City residents too?",
      a: "Yes. We serve all of Navajo County and the I-40 corridor including Holbrook, Joseph City, Snowflake, Taylor, and the entire northeastern Arizona region. Our remote courier service works identically — complete your application online and we handle everything.",
    },
    {
      q: "What if I'm Hopi or Navajo Nation and need tribal documentation for my passport?",
      a: "Tribal enrollment cards, while valuable identification, are not accepted as primary photo ID for U.S. passport applications. You will need a state-issued photo ID (Arizona driver's license or ID card) or other acceptable federal identification alongside your certified birth certificate. Fast Passport Center can guide you through the documentation requirements.",
    },
    {
      q: "I'm a Route 66 tourist from another country — can you help me if I need passport services while in Winslow?",
      a: "Fast Passport Center primarily serves U.S. citizens applying for U.S. passports. If you are an international tourist visiting Winslow on Route 66 and need consular services, please contact your country's nearest consulate — likely in Phoenix, Los Angeles, or Las Vegas. For U.S. citizens traveling Route 66 who discover an expired passport before international travel, we can help.",
    },
    {
      q: "How does the high desert climate affect passport document shipping from Winslow?",
      a: "Winslow's 5,000-foot elevation high desert climate presents unique shipping challenges — freezing winter temperatures, summer heat exceeding 100°F, and spring windstorms. Standard USPS mail can be unreliable during extreme weather. Fast Passport Center's UPS overnight courier with temperature-controlled handling and full tracking ensures your documents arrive safely regardless of desert weather conditions.",
    },
    {
      q: "Is it faster to drive to Flagstaff or Albuquerque for passport services?",
      a: "Flagstaff does not have a passport agency — it only has acceptance facilities. Albuquerque has no U.S. passport agency either. The closest passport agency to Winslow is the Western Passport Center in Tucson (260 miles). Fast Passport Center's courier service is significantly more practical than driving to any regional agency, and our 2–9 business day turnaround is faster than any other option available to Winslow residents.",
    },
  ],
  photoLocations: [
    { name: "Walgreens — Flagstaff", address: "1000 S Milton Rd, Flagstaff, AZ 86001", hours: "Mon–Sun: 7AM–10PM" },
    { name: "CVS Pharmacy — Flagstaff", address: "2610 S Woodlands Village Blvd, Flagstaff, AZ 86001", hours: "Mon–Sun: 8AM–9PM" },
    { name: "Walmart Supercenter — Show Low", address: "5401 S White Mountain Rd, Show Low, AZ 85901", hours: "Mon–Sun: 8AM–8PM" },
    { name: "Walgreens — Holbrook", address: "1602 Navajo Blvd, Holbrook, AZ 86025", hours: "Mon–Sun: 8AM–9PM" },
    { name: "UPS Store — Flagstaff", address: "1235 S Plaza Way, Flagstaff, AZ 86001", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–4PM" },
    { name: "FedEx Office — Flagstaff", address: "1800 S Milton Rd, Ste 15, Flagstaff, AZ 86001", hours: "Mon–Fri: 8AM–6PM, Sat: 9AM–3PM" },
  ],
  dmvLocations: [
    { name: "AZ MVD — Holbrook", address: "2100 Navajo Blvd, Holbrook, AZ 86025", hours: "Mon–Fri: 8:00AM–5:00PM", note: "REAL ID and driver's license renewals for Holbrook, Winslow, and Navajo County residents. About 30 miles east of Winslow.", featured: true },
    { name: "AZ MVD — Show Low", address: "161 E Deuce of Clubs, Show Low, AZ 85901", hours: "Mon–Fri: 8:00AM–5:00PM", note: "Serves Show Low, Snowflake, Taylor, and southern Navajo County residents. About 55 miles south.", featured: false },
    { name: "AZ MVD — Flagstaff", address: "1851 S Milton Rd, Flagstaff, AZ 86001", hours: "Mon–Fri: 8:00AM–5:00PM", note: "Serves Flagstaff and Coconino County residents. About 60 miles west of Winslow.", featured: false },
  ],
  airports: [
    {
      code: "INW",
      name: "Winslow-Lindbergh Regional Airport",
      distance: "1 mile west of downtown Winslow",
      address: "701 Airport Rd, Winslow, AZ 86047",
      note: "General aviation airport with no commercial passenger service. Historic airport named for Charles Lindbergh. For commercial flights, Winslow residents use Flagstaff (FLG) or Phoenix (PHX).",
      flightUrl: "https://www.winslowaz.gov/271/Airport",
      flightLabel: "INW Airport",
      featured: true,
    },
    {
      code: "FLG",
      name: "Flagstaff Pulliam Airport",
      distance: "60 miles west of Winslow",
      address: "6200 S Pulliam Dr, Flagstaff, AZ 86005",
      note: "Northern Arizona regional airport with American Airlines service to Phoenix and Dallas. Connects to international flights at PHX. About 1 hour via I-40.",
      flightUrl: "https://www.flagstaff.az.gov/1237/Pulliam-Airport",
      flightLabel: "FLG Airport",
      featured: false,
    },
    {
      code: "PHX",
      name: "Phoenix Sky Harbor International Airport",
      distance: "175 miles southwest of Winslow",
      address: "3400 E Sky Harbor Blvd, Phoenix, AZ 85034",
      note: "Arizona's largest international airport with extensive global routes. About 3 hours via I-40 and I-17.",
      flightUrl: "https://www.skyharbor.com/",
      flightLabel: "PHX Airport",
      featured: false,
    },
    {
      code: "ABQ",
      name: "Albuquerque International Sunport",
      distance: "210 miles east of Winslow",
      address: "2200 Sunport Blvd SE, Albuquerque, NM 87106",
      note: "Major New Mexico international hub with domestic and international routes. About 3.5 hours east via I-40. Viable alternative for Winslow residents heading east.",
      flightUrl: "https://www.abqsunport.com/",
      flightLabel: "ABQ Airport",
      featured: false,
    },
  ],
};